import { subscribe } from '@/utils'

import { Params, Response } from './type'

const track = async (params: Params): Promise<Response> => {
	try {
		const body = {
			order_id: params.order_id
		}
		const res = await subscribe.post<Response>('sales/track-delivery', body)
		return res.data
	} catch (e) {
		throw e
	}
}

export const service = {
	track
}

